import { computed, ref } from 'vue'
import useAppState, { ViewType } from '@/composables/ui/ui'

export enum ActivePostPage {
  Newest = 'PostNewestList',
  Oldest = 'PostOldestList',
  Best = 'PostBestList',
  Show = 'PostShowList',
  TOP_NEWEST = 'PostTopNewestList',
}

const activePage = ref<ActivePostPage>(ActivePostPage.Oldest)

export default function usePostListMenu() {
  const isNewest = computed(() => {
    return activePage.value === ActivePostPage.Newest
  })

  const isOldest = computed(() => {
    return (
      activePage.value === ActivePostPage.Oldest ||
      activePage.value === ActivePostPage.Show
    )
  })

  const isBest = computed(() => {
    return activePage.value === ActivePostPage.Best
  })

  const init = () => {
    const { viewType } = useAppState()

    if (viewType.value === ViewType.TOP_NEWEST) {
      activePage.value = ActivePostPage.TOP_NEWEST
    }
  }

  init()

  return {
    activePage,
    isNewest,
    isOldest,
    isBest,
  }
}
